<template lang="pug">
.v-field.field(:class="{'form-error': field && localErrors && localErrors.length && !field.multiple}")
	//- multiple field: create list of v-field's with add/remove button
	template(v-if="field.multiple && field.type !== 'file' && field.type !== 'select'")
		.field__multiple-list(v-if="Array.isArray(localValue) && localValue.length")
			.field__multiple-list-grid
				template(v-for="(item, index) in localValue" :key="index")
					.field__multiple-list-item
						v-field(:field="{...field, multiple: false, label: field.label, errors: localErrors ? localErrors[index] : null}"
								v-model="localValue[index]")
						button.field__multiple-list-remove.link(v-if="localValue.length > multipleLimitMin"
								type="button"
								@click="multipleRemove(index)")
								| {{ field.variables?.remove || 'Remove' }}
		transition(name="fade")
			button.field__multiple-list-add.link(
					type="button"
					@click="multipleAdd"
					v-if="!localValue || localValue.length < field.multipleLimit")
					| {{ field.variables?.add || 'Add' }}

	//- regular field
	template(v-else)

		template(v-if="field.type === 'select' && !field.multiple")
			v-field-select(:field="field" :model-value="localValue" @update:model-value="handleInput")
		template(v-else-if="field.type === 'select' && field.multiple")
			v-field-multi-select(:field="field" :model-value="localValue" @update:model-value="handleInput")
		template(v-else-if="field.type === 'select-time' && !field.multiple")
			v-field-select-time(:field="field" :model-value="localValue" @update:model-value="handleInput" @update:day-off="handleDayOff")
		template(v-else-if="field.type === 'group-field' && !field.multiple")
			v-field-group(:field="field" :model-value="localValue" @update:model-value="handleInput")
		template(v-else-if="field.type === 'promocode'")
			v-field-promocode(:field="field" :model-value="localValue" @update:model-value="handleInput"
				@removePromocode="handleRemovePromocode"
				@addPromocode="handleAddPromocode"
			)

		template(v-else-if="field.type === 'tab-select'")
			v-tabs-select(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'modal-select-multiple'")
			v-field-modal-select-multiple(:field="field" :model-value="localValue" @update:model-value="handleInput" @map-filter-changed="sendMapFilter")

		template(v-else-if="field.type === 'modal-select'")
			v-field-modal-select(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'tumbler-list'")
			v-field-tumbler-list(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'check-list'")
			v-field-check-list(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'radio-list'")
			v-field-check-list(:field="field" radio :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'count'")
			v-field-count(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'range'")
			v-field-range(:field="field" :model-value="localValue" @update:model-value="handleInput")
		template(v-else-if="field.type === 'toggler'")
			v-field-toggler(:field="field" :model-value="localValue" @update:model-value="handleInput")
		template(v-else-if="field.type === 'table-sort'")
			v-field-table-sort(:field="field" :model-value="localValue" @update:model-value="handleInput")
		template(v-else-if="field.type === 'range-slider'")
			v-field-range-slider(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'rating'")
			v-rating(:field="field" v-model="localValue" @update:model-value="handleInput" input)

		template(v-else-if="field.type === 'type-picker'")
			v-field-type-picker(:field="field" v-model="localValue"  @update:model-value="handleInput")

		template(v-else-if="field.type === 'file'")
			v-field-file(:field="field" @fileinput="fileInput" @fileremove="fileRemove" :model-value="localValue" @update:model-value="handleInput")
		template(v-else-if="field.type == 'avatar'")
			v-field-avatar(:field="field" @fileinput="fileInput" @fileremove="fileRemove")
		template(v-else-if="field.type === 'view-picker'")
			v-field-view-picker(:field="field" :model-value="localValue" @update:model-value="handleInput" @click="field.click" :disabled="field.disabled")

		template(v-else-if="field.type === 'map'")
			v-field-map(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'date'")
			v-datepicker(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'tel2'")
			v-field-tel(:field="field" :model-value="localValue" @update:model-value="handleInput")
		template(v-else-if="field.type === 'schedule'")
			v-field-schedule(:field="field" :model-value="localValue" @update:model-value="handleInput" @emmitData="handleInput")
		template(v-else-if="field.type === 'code'")
			v-field-code(:code-data="field"
					:timer="field.timerValue"
					:model-value="localValue"
					@update:model-value="handleInput"
					@request-code="requestCode")

		template(v-else-if="field.type === 'translate'" )
			v-field-translate-list(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'work-schedule'" )
			v-field-work-schedule(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'contacts'" )
			v-field-contacts(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'text-edit'" )
			v-field-tel-edit(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'double-text'" )
			v-field-double-text(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'page-select'" )
			v-field-page-select(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else)
			v-field-text(:field="field" :model-value="localValue" :disabled="field.disabled"  :class="{'hidden': field.type === 'hidden'}" @update:model-value="handleInput")

		template(v-if="Array.isArray(localErrors) && localErrors && localErrors.length")
			template(v-for="error in localErrors")
				.field__errors.flc
					template(v-if="Array.isArray(error.message) && error.message.length")
						.field__error.flc(v-for="errorItem in error.message" v-html="errorItem")
					template(v-else)
						.field__error.flc(v-html="error.message")
		template(v-if="field.errors")
			template(v-if="Array.isArray(field.errors) && field.errors.length")
				.field__errors.flc
					template(v-for="error in field.errors")
						.field__error.flc(v-html="error")
</template>

<script>
import controller from '../scripts/controller/controller';

export default {
	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		errors: {
			type: Array,
			default: null,
		},

		modelValue: {
			type: [Array, Object, String, Number, Boolean, Date],
			default: null
		},
	},

	emits: [
		'fileinput',
		'fileremove',
		'update:model-value',
		'removePromocode',
		'addPromocode',
		'request-code',
		'addPromocode',
		'emmitData',
		'update:day-off',
		'map-filter-changed'
	],

	data() {
		return {
			localValue: null,
			localErrors: null,
			touch: controller.touch
		};
	},

	computed: {
		multipleLimitMin() {
			let limit = this.field && this.field.multipleLimitMin;
			return isNaN(limit) ? 1 : limit;
		}
	},

	watch: {
		modelValue: {
			immediate: true,
			handler() {
				this.updateLocalValue();
			}
		},

		field: {
			immediate: true,
			handler() {
				this.localErrors = this.errors;
			}
		}
	},

	methods: {
		requestCode(e) {
			this.$emit('request-code', e);
		},

		handleRemovePromocode(e) {
			this.$emit('removePromocode', e);
		},

		emmitData(e) {
			this.$emit('emmitData', e);
			this.localValue = e;
			this.$emit('update:model-value', e);
		},

		handleDayOff(e) {
			this.$emit('update:day-off', e);
		},

		handleAddPromocode(e) {
			this.$emit('addPromocode', e);
		},


		fileInput(e) {
			this.$emit('fileinput', e);
		},

		fileRemove(e) {
			this.$emit('fileremove', e);
		},

		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		multipleAdd() {
			if (!Array.isArray(this.localValue)) {
				this.localValue = [];
			}

			if (this.localValue.length < this.field.multipleLimit) {
				this.localValue.push(null);
			}
		},

		multipleRemove(index) {
			this.localValue.splice(index, 1);

			if (Array.isArray(this.localErrors)) {
				this.localErrors.splice(index, 1);
			}
		},

		handleInput(value) {
			this.localValue = value;
			this.$emit('update:model-value', this.localValue);
		},

		sendMapFilter(area) {
			this.$emit('map-filter-changed', area);
		}
	}
};
</script>
